import { motion } from 'framer-motion'
import { ArrowRight } from 'lucide-react'
import { APP_REGISTER_URL } from '../constants/nav'
import FadeIn from '../components/animations/FadeIn'

export default function Demo() {
  return (
    <section className="bg-off-white py-20">
      <div className="max-w-xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <FadeIn>
          <h1 className="text-navy text-2xl sm:text-[36px] font-heading font-semibold mb-4">
            See SiteDeck Pro in action
          </h1>
        </FadeIn>
        <FadeIn delay={0.1}>
          <p className="text-slate mb-10 text-lg">
            Log in to the demo environment and explore every feature — no setup required.
          </p>
        </FadeIn>

        <FadeIn delay={0.2}>
          <motion.div
            whileHover={{ y: -2, boxShadow: '0 8px 24px rgba(0,0,0,0.06)' }}
            transition={{ duration: 0.2 }}
            className="bg-white rounded-xl border border-gray-100 p-6 sm:p-8 text-left mb-6"
          >
            <table className="w-full text-sm">
              <tbody className="divide-y divide-gray-100">
                {[
                  { label: 'URL', value: 'app.sitedeck.pro' },
                  { label: 'Email', value: 'demo-admin@sitedeck.pro' },
                  { label: 'Password', value: 'Demo2025!SiteDeck' },
                  { label: 'Org', value: 'Apex Utility Contractors (Enterprise plan — all features unlocked)' },
                ].map((row) => (
                  <tr key={row.label}>
                    <td className="py-3 pr-4 text-slate font-medium w-24">{row.label}</td>
                    <td className="py-3 text-navy">{row.value}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </motion.div>
        </FadeIn>

        <FadeIn delay={0.3}>
          <p className="text-slate text-sm mb-8">
            Demo data resets periodically. Feel free to explore anything.
          </p>
        </FadeIn>

        <FadeIn delay={0.4}>
          <a
            href={APP_REGISTER_URL}
            className="inline-flex items-center text-field-orange font-medium hover:underline"
          >
            Ready to get started? Create your free account
            <ArrowRight className="w-4 h-4 ml-1" />
          </a>
        </FadeIn>
      </div>
    </section>
  )
}
